import { Entity } from '../entity';
import { PageTitles } from '../interfaces/types';

interface IAmsHit {
  id: string;
  score: string;
  address: string;
  source: string;
  lastUpdated: string;
  buildingType: string;
  payload: {
    id: string;
    unit: string;
    floor: string;
    streetNumberPrefix: string;
    streetNumber: string;
    streetNumberSuffix: string;
    dirPrefix: string;
    streetTypePrefix: string;
    streetName: string;
    streetTypeSuffix: string;
    dirSuffix: string;
    city: string;
    province: string;
    postalCode: string;
    buildingType: string;
    country: string;
  };
}

export interface IAmsAddress {
  action: string;
  response: string;
  responseData: {
    numhits: number;
    hit: IAmsHit[];
  };
}

export interface IAms {
  addressComment: string;
  fibreComment: string;
  hazardComment: string;
}

@Entity({
  name: PageTitles.ams,
})
export class Ams implements IAms {
  addressComment: string;
  fibreComment: string;
  hazardComment: string;

  constructor(
    ams: IAms = {
      addressComment: '',
      fibreComment: '',
      hazardComment: '',
    }
  ) {
    const { addressComment, fibreComment, hazardComment } = ams;

    this.addressComment = addressComment;
    this.fibreComment = fibreComment;
    this.hazardComment = hazardComment;
  }
}
